"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.defaultLocale = void 0;
exports.defaultLocale = 'ru';
var signatureDefaultViewColor = '#b0babf';
var signatureDefaultEditColor = '#474f53';
var signatureInvalidColor = '#f8c41b';
var signatureInvalidLightColor = '#fdf49b';
var signatureValidColor = '#059f50';
var signatureValidLightColor = '#e0f5e9';
var mainColor = '#63666a';
var lightGreyColor = '#e6e6e6';
var contrastColor = '#ffffff';
var lightBackgroundColor = '#f1f1f1';
var linkColor = '#2f80ed';
var circularProgressSize = '20px';
exports.defaultTheme = {
    linkColor: linkColor,
    circularProgressSize: circularProgressSize,
    defaultBorder: "1px solid " + lightGreyColor,
    signature: {
        defaultView: signatureDefaultViewColor,
        defaultEdit: signatureDefaultEditColor,
        valid: signatureValidColor,
        validLight: signatureValidLightColor,
        invalid: signatureInvalidColor,
        invalidLight: signatureInvalidLightColor,
    },
    toggleButtons: {
        mainColor: mainColor,
        mainBackground: lightBackgroundColor,
        hoverColor: contrastColor,
        hoverBackground: mainColor,
    },
};
